import React from 'react';
import BrokerConnection from '../../components/BrokerConnection/BrokerConnection';

const Brokers: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Мои биржи</h1>
        <p style={{ color: '#9ca3af', marginTop: '8px' }}>
          Подключите брокерский счёт для торговли на бирже
        </p>
      </div>

      <BrokerConnection />
    </div>
  );
};

export default Brokers;
